// extracted by mini-css-extract-plugin
module.exports = {"help-section":"styles_help-section__Bfbb5","help-section--dropdown":"styles_help-section--dropdown__3sVTB"};